import { Link, useRouteError } from 'react-router-dom';

import { Container } from '@sshop/ui';
import { useTranslation } from '@sshop/i18n';
import { useLocale } from '@/shared/hooks/useLocale';
import { routes } from '@/shared/lib/routes';

export function RootErrorBoundary() {
  const { t } = useTranslation();
  const locale = useLocale();
  const error = useRouteError();
  const message = error instanceof Error ? error.message : t('app.unexpectedError');

  return (
    <Container size="md" className="py-20">
      <h1 className="text-3xl font-semibold">{t('app.somethingWentWrong')}</h1>
      <p className="mt-2 text-fg-secondary">{message}</p>
      <Link
        to={routes.home(locale)}
        className="mt-6 inline-block rounded-md bg-accent px-4 py-2 text-accent-fg hover:bg-accent-hover"
      >
        {t('app.goHome')}
      </Link>
    </Container>
  );
}
